import { createSelector } from '@reduxjs/toolkit';
import { IGlobalReduxStore } from 'store';

const getUserPermissions = (state: IGlobalReduxStore) => state.auth.permissions;

export const isOrganizationMultiLocationTieringEnabledSelector = createSelector(
  getUserPermissions,
  (userPermissions) => {
    if (!userPermissions?.MULTI_LOCATION_TIERING) return false;
    return userPermissions?.MULTI_LOCATION_TIERING?.access.includes('read');
  },
);
